<template>
  <div class="main-content">
    <img src="./images/10.png" class="img-1" />
    <p class="label-1">提交成功</p>
    <p class="label-2">请耐心等待工作人员与您联系</p>
    <img src="./images/12.png" class="img-2" />
    <input
      type="text"
      v-model="plateNum"
      class="input-1"
      maxlength="10"
      @change="btKeyUp"
      placeholder="您的车牌号"
    />
    <p class="mode-1" v-show="!selectMode">请选择托管模式</p>
    <button class="input-1 input-2" @click="showMode">{{ selectMode }}</button>
    <input
      type="text"
      class="input-1 input-3"
      v-model="milesTraveled"
      @keyup="checkMiles"
      maxlength="8"
      placeholder="请输入车辆行驶公里数(km)"
    />
    <van-popup v-model="show" position="bottom" class="bottom-ul">
      <ul>
        <li @click="chooseMode(1)">
          <p class="p-1">灵活托管</p>
          <p class="p-2">以天为单位，自主上下架</p>
        </li>
        <li @click="chooseMode(2)">
          <p class="p-1">完全托管</p>
          <p class="p-2">省时省心，安心拿收益</p>
        </li>
        <li class="li-1" @click="show = false">取消</li>
      </ul>
    </van-popup>
    <button class="btn-1" @click="fnSaveApply"></button>
  </div>
</template>

<script>
import { saveApply } from "@/services/C2C";
import Vue from "vue";
import { Popup } from "vant";
import { addSensorsTrack } from "@/libs/utils";

Vue.use(Popup);
export default {
  name: "submitSuccess",
  data() {
    return {
      show: false,
      selectMode: "",
      plateNum: "",
      hostingForm: 1, //托管行驶
      milesTraveled: "" //行驶里程
    };
  },
  methods: {
    checkMiles(e) {
      this.milesTraveled = e.target.value.replace(/[^\d.]/g, "");
    },
    btKeyUp(e) {
      let val = e.target.value.replace(/[^\u4E00-\u9FA5A-Za-z0-9]/g, "");
      if (val.length > 10) {
        val = val.slice(0, 9);
      }
      this.plateNum = val;
    },
    showMode() {
      this.show = true;
    },
    chooseMode(mode) {
      console.log(mode);
      this.show = false;
      if (mode === 1) {
        this.selectMode = "灵活托管";
        this.hostingForm = 1;
      } else {
        this.selectMode = "完全托管";
        this.hostingForm = 2;
      }
    },
    fnSaveApply() {
      if (!this.plateNum) {
        this.$toast("请输入车牌号");
        return false;
      }
      if (!this.selectMode) {
        this.$toast("请选择托管模式");
        return false;
      }
      if (!this.milesTraveled) {
        this.$toast("请输入车辆行驶公里数");
        return false;
      }
      const res = /[^\d.]/g;
      if (res.test(this.milesTraveled)) {
        this.$toast("请输入正确的车辆行驶公里数");
        return false;
      }
      const data = {
        userId: this.$route.query.userId,
        ownerSim: this.$route.query.ownerSim,
        ownerName: this.$route.query.ownerName,
        plateNum: this.plateNum,
        brandId: this.$route.query.brandId,
        seriesId: this.$route.query.seriesId,
        milesTraveled: Math.floor(this.milesTraveled * 100) / 100,
        hostingForm: this.hostingForm,
        source: 1,
        channelId:
          this.$route.query.utm_source + "," + this.$route.query.utm_medium
      };

      saveApply(data).then(res => {
        console.log(res);
        if (res.code === 200) {
          //判断是否在小程序环境
          if (window.__wxjs_environment === "miniprogram") {
            addSensorsTrack("mpCustomButtonClick", {
              $element_content: "lijilq",
              $url: window.location.href,
              $title: "领取成功"
            });
            // eslint-disable-next-line no-undef
            wx.miniProgram.navigateTo({
              url: "/pages/c2cInvite/success"
            });
          } else {
            addSensorsTrack("webCustomButtonClick", {
              $element_content: "lijilq",
              $url: window.location.href
            });
            this.$router.push({
              path: "/C2C/receive-success?newCoupon=0"
            });
          }
        } else {
          this.$toast(res.message);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.main-content {
  width: 100%;
  height: 100vh;
  background: rgb(250, 249, 248);
  padding-top: 70px;
  box-sizing: border-box;
  position: relative;
  .img-1 {
    width: 92px;
  }
  .label-1 {
    font-family: FZLTCHJW--GB1-0;
    font-size: 48px;
    color: #141e25;
    letter-spacing: 0;
    text-align: center;
    margin: 0;
    font-weight: bold;
  }
  .label-2 {
    font-family: FZLTHJW--GB1-0;
    font-size: 26px;
    color: #778690;
    letter-spacing: 0;
    text-align: center;
    line-height: 38px;
    margin: 0;
  }
  .img-2 {
    width: 662px;
    margin-top: 70px;
  }
  .mode-1 {
    position: absolute;
    top: 528px;
    left: 148px;
    height: 53px;
    line-height: 53px;
    padding-left: 100px;
    width: 518px;
    box-sizing: border-box;
    text-align: left;
    font-family: PingFangSC-Regular;
    font-size: 25px;
    color: #778690;
  }
  .input-1 {
    position: absolute;
    top: 460px;
    left: 148px;
    height: 53px;
    line-height: 53px;
    background: transparent;
    border: none;
    padding-left: 100px;
    width: 518px;
    box-sizing: border-box;
    text-align: left;
  }
  .input-2 {
    top: 548px;
    cursor: pointer;
  }
  .input-3 {
    top: 636px;
  }
  .bottom-ul {
    width: 100%;
    height: 362px;
    ul {
      width: 100%;
      height: 100%;
      li {
        width: 100%;
        height: 124px;
        border-bottom: 2px solid #f1f3f5;
        margin-bottom: 2px;
        .p-1 {
          box-sizing: border-box;
          padding-top: 24px;
          font-family: FZLTHJW--GB1-0;
          font-size: 36px;
          color: #000000;
          text-align: center;
          margin: 0;
        }
        .p-2 {
          font-family: FZLTHJW--GB1-0;
          font-size: 24px;
          color: #778690;
          text-align: center;
          margin: 0;
        }
      }
      .li-1 {
        height: 100px;
        line-height: 100px;
        font-family: FZLTHJW--GB1-0;
        font-size: 36px;
        color: #778690;
        text-align: center;
        margin-top: 10px;
        margin-bottom: 0;
        border-bottom: none;
      }
    }
  }
  .btn-1 {
    position: absolute;
    left: 44px;
    top: 740px;
    background: transparent;
    border: none;
    width: 662px;
    height: 120px;
  }
}
</style>
